import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import StarIcon from '@mui/icons-material/Star';
import './ratingstar.scss';

const NUM_STARTS = 5;

const Star = ({
  starValue,
  hoverRating,
  rating,
  handleMouseEnter,
  handleMouseLeave,
  setRating,
}) => {
  const isFilled = starValue <= (hoverRating || rating);
  const starClassName = `RatingStar__star ${isFilled ? 'filled' : ''}`;

  return (
    <StarIcon
      className={starClassName}
      sx={{ fontSize: 40 }}
      onMouseEnter={() => handleMouseEnter(starValue)}
      onMouseLeave={handleMouseLeave}
      onClick={() => setRating(starValue)}
    >
      <span className="sr-only">{starValue}</span>
    </StarIcon>
  );
};

const RatingStar = ({ rating, onRatingChange }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleMouseEnter = useCallback((value) => setHoverRating(value), []);

  const handleMouseLeave = useCallback(() => setHoverRating(0), []);

  const setRating = useCallback(
    (value) => onRatingChange(value),
    [onRatingChange]
  );

  return (
    <div className="RatingStar">
      {Array.from({ length: NUM_STARTS }).map((_, i) => (
        <Star
          key={`star-${i}`}
          starValue={i + 1}
          hoverRating={hoverRating}
          rating={rating}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          setRating={setRating}
        />
      ))}
    </div>
  );
};

RatingStar.propTypes = {
  rating: PropTypes.number.isRequired,
  onRatingChange: PropTypes.func.isRequired,
};

export default RatingStar;
